import React from 'react';
import * as Yup from 'yup';
import { Form, withFormik } from 'formik';
import { Input } from '../../Form/Input';
import { Button } from '../../Button';
import './EditPasswordPopup.css';

const EditPasswordPopup = () => (
  <div className="row">
    <div className="col px-5 py-3">
      <Form className="row">
        <div className="col-12 col-md-6">
          <div className="form-row">
            <Input
              labelClassName="text-gray-light t-14"
              name="current_password"
              label="Current Password"
              type="password"
            />
          </div>
        </div>
        <div className="col-12">
          <div className="form-row">
            <Input
              labelClassName="text-gray-light t-14"
              name="password"
              label="New Password"
              type="password"
            />
            <Input
              labelClassName="text-gray-light t-14"
              name="password_confirmation"
              label="New Password"
              type="password"
            />
          </div>
          <div className="form-row mt-4">
            <div className="col text-center">
              <Button
                flat
                rounded
                className="t-15 text-uppercase btn-primary"
                title="Update"
                type="submit"
              />
            </div>
          </div>
        </div>
      </Form>
    </div>
  </div>
);
export default withFormik({
  handleSubmit: (values, { props, setSubmitting }) =>
    props.onSubmit && props.onSubmit(values, setSubmitting),
  validationSchema: Yup.object().shape({
    current_password: Yup.string().required('Current Password is required'),
    password: Yup.string()
      .min(8, 'Password should have at least 8 characters')
      .required('New Password is required'),
    password_confirmation: Yup.string()
      .min(8, 'Password should have at least 8 characters')
      .oneOf([Yup.ref('password'), null], 'Passwords are not the same')
      .required('New Password is required'),
  }),
  displayName: 'LoginForm',
})(EditPasswordPopup);



// WEBPACK FOOTER //
// ./src/components/Popup/EditPasswordPopup/EditPasswordPopup.js